module.exports = __webpack_public_path__ + "static/media/option-dot.67bb6e60.svg";